(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("promotionsApi", [], factory);
	else if(typeof exports === 'object')
		exports["promotionsApi"] = factory();
	else
		root["promotionsApi"] = factory();
})(self, () => {
return 